import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


// Gross thing that I have to do to get around a warning from react-datepicker. It passes a ref to its custom input,
// but as of React 16 refs cannot be passed to functional components. Since FontAwesomeIcon is a functional component
// I'm forced to wrap it in a React Component to get things to work without barfing.
class DatePickerCustomInput extends React.Component {
    render() {
        return (
            <div {...this.props}>
                <FontAwesomeIcon icon={['fas', 'calendar-alt']} className="calendar-filter-button"
                                 style={{color: '#0183DA'}}/>
            </div>
        );
    }
}

export default DatePickerCustomInput;
